import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import ThemeContext from '../../../providers/ThemeProvider';
import SectionTitle from './SectionTitle';

const CollapsableSection = ({
  title,
  collapsed,
  id,
  isSubCat,
  className,
  children,
  onToggle,
}) => {
  const theme = useContext(ThemeContext);

  return (
    <>
      <div className={classNames('section', className)} id={id}>
        <SectionTitle
          collapsed={collapsed}
          isSubCat={isSubCat}
          onToggleCollapse={onToggle}
          title={title}
        />
        <div
          className={classNames('section__content', {
            'section__content--collapsed': collapsed,
          })}
        >
          {children}
        </div>
      </div>
      <style jsx>{`
        .section__content {
          display: block;
        }
        .section__content--collapsed {
          display: none;
        }
        .isSubcat-section {
          flex: 1;
          color: ${theme.colors.primary};
          border: none;
          padding: 5px 10px 5px 15px;
          border-radius: 8px;
          gap: 8px;
          position: relative;
          margin-right: 5px;
        }
      `}</style>
    </>
  );
};

CollapsableSection.propTypes = {
  className: PropTypes.string,
  collapsed: PropTypes.bool,
  id: PropTypes.string,
  isSubCat: PropTypes.bool,
  onToggle: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

CollapsableSection.defaultProps = {
  className: '',
  collapsed: false,
  id: '',
  isSubCat: false,
  onToggle: () => false,
  title: '',
};

export default CollapsableSection;
